export const NPP_URL = 'https://www.tempus.com/notice-of-privacy-practices/';
export const PRIVACY_POLICY_URL = 'https://www.tempus.com/privacy/';
export const TERMS_OF_USE_URL = 'https://www.tempus.com/terms-of-use/';

export const CALL_LINK = 'tel:888-321-1082';
export const SMS_LINK = 'sms:888-321-1082';
